import { render, staticRenderFns } from "./TeamsTab.vue?vue&type=template&id=07130546&scoped=true&"
import script from "./TeamsTab.vue?vue&type=script&lang=js&"
export * from "./TeamsTab.vue?vue&type=script&lang=js&"
import style0 from "./TeamsTab.vue?vue&type=style&index=0&id=07130546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07130546",
  null
  
)

export default component.exports